import useHasFeature from "@/features/useHasFeature";
import { IMetadata } from "@/view/utils/decodableContent";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import { ContentLevel } from "@/types/models/ContentLevel.interface";
import { isSupportedEnglishContent } from "@/utils/generatedContent";

import { ContentType } from "@/view/constants/contentTypes";

export const VIEW_PAGE_EXPORTABLE_FEATURE = "view_page_exportable";
/**
 * Hook to determine if the Exportable feature should be visible to a user for a given content level.
 **/
const useExportableVisibility = ({
  articleType,
  currentLevel,
  contentMetadata = [],
  contentType,
}: {
  articleType?: string;
  currentLevel?: ContentLevel;
  contentMetadata?: IMetadata[];
  contentType: ContentType;
}) => {
  const { isTeacher } = useGetUserProperties() || {};

  const [hasExportableFeature] = useHasFeature(VIEW_PAGE_EXPORTABLE_FEATURE);

  const isSupportedContent = isSupportedEnglishContent({
    articleType,
    contentType,
    currentLevel,
    contentMetadata,
  });

  return Boolean(isTeacher && hasExportableFeature && isSupportedContent);
};

export default useExportableVisibility;
